export const statsToArray = (content) => {
  const createStatObject = (title, subtitle, text) => {
    if (!(text || title || subtitle)) return null;

    return {
      title,
      subtitle,
      text,
    };
  };

  const { stat1Title, stat1Subtitle, stat1Text } = content;
  const stat1 = createStatObject(stat1Title, stat1Subtitle, stat1Text);
  const { stat2Title, stat2Subtitle, stat2Text } = content;
  const stat2 = createStatObject(stat2Title, stat2Subtitle, stat2Text);
  const { stat3Title, stat3Subtitle, stat3Text } = content;
  const stat3 = createStatObject(stat3Title, stat3Subtitle, stat3Text);
  const { stat4Title, stat4Subtitle, stat4Text } = content;
  const stat4 = createStatObject(stat4Title, stat4Subtitle, stat4Text);

  // Remove any nulls as a failsafe
  return [stat1, stat2, stat3, stat4].filter((stat) => stat);
};

export const combineToRichText = (title, subtitle, richText) => {
  const text = richText ? JSON.parse(richText) : null;
  const firstParagraphNode = text ? text.content.splice(0, 1) : null;
  const remainingParagraphNodes =
    text?.content.length > 1 ? text.content : null;

  const contentTemplate = (string) => ({
    nodeType: 'text',
    value: string,
    marks: [
      {
        type: 'span',
      },
    ],
    data: {},
  });

  const richTextTemplate = {
    nodeType: 'document',
    data: {},
    content: [
      {
        nodeType: 'paragraph',
        data: {},
        content: [],
      },
    ],
  };

  // Combine title, subtitle and content of first paragraph into a single block in rich text template
  if (title) {
    richTextTemplate.content[0].content.push(contentTemplate(title));
  }

  if (subtitle) {
    richTextTemplate.content[0].content.push(contentTemplate(subtitle));
  }

  if (firstParagraphNode) {
    richTextTemplate.content[0].content.push(...firstParagraphNode[0].content);
  }

  // Add any remaining paragraph nodes to the template
  if (remainingParagraphNodes) {
    richTextTemplate.content.push(...remainingParagraphNodes);
  }

  return JSON.stringify(richTextTemplate);
};
